import { useEffect } from "react";
import { isDevelopment } from "helpers/env";

// When a feature is rendered in an HQ3 iFrame,
// it may be capable of handling its own routing.
// This hook allows it to communicate up to its parent
// to notify of changes in view.

export default function useSelfRoute(route: string) {
  useEffect(
    () => {
      if (window.parent && route) {
        const targetOrigin = isDevelopment() ? "*" : "https://hq.upserve.com";
        window.parent.postMessage(
          {
            app: "Workforce",
            event: "push_route",
            value: route,
          },
          targetOrigin
        );
      }
    },
    [route]
  );
}
